import { PrometheusQuery } from "./PrometheusQuery";

export class CPUTemperatureQuery extends PrometheusQuery {
  protected _id: string = "calculated:cpu_max_temperature";

  public override getPossibleValues() {
    return [
      { id: "CPU Temperature", color: "#FF0000" }
    ]
  };

  public override getRefinedData() {
    const refinedData = [];

    if (this.isEmpty()) return [];

    for (let i = 0; i < this._queryData.data.result[0].values.length; i += 1) {
      refinedData.push({
        date: this.formatDate(this._queryData.data.result[0].values[i][0]),
        "CPU": this._queryData.data.result[0]?.values[i][1]
      })
    }

    return refinedData;
  }

  public override getDomain() {
    if (this.isEmpty()) return [0, 100]
    return undefined;
  }

  public override getMiddleValue() {
    return 50;
  }

  public override getValueLabel() {
    return "°C";
  }
}